import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { IApiResponse } from '../models';
import {
  IMarketingReportDto,
  IMarketingReportFilterDto,
  IMenuReportDto,
  IMenuReportFilterDto,
  IOrderReportDto,
  IOrderReportFilterDto,
  IVisitorReportDto,
} from '../models/report.model';

@Injectable()
export class ReportService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getOrderReport(
    model: IOrderReportFilterDto
  ): Observable<IOrderReportDto> {
    return this.post(`admin/report/order`, model);
  }

  public getMarketingReport(
    model: IMarketingReportFilterDto
  ): Observable<IMarketingReportDto> {
    return this.post(`admin/report/marketing`, model);
  }

  public getMenuReport(
    model: IMenuReportFilterDto
  ): Observable<IMenuReportDto[]> {
    return this.post(`admin/report/menu`, model);
  }

  public getVisitorReport(
    model: IMarketingReportFilterDto
  ): Observable<IVisitorReportDto[]> {
    return this.post(`admin/report/visitor`, model);
  }

  public sendOrderReport(
    model: IOrderReportFilterDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`report/order`, model);
  }
}
